import * as React from "react";
import Component from "../../AbstractComponent";
import TaskSummary from "./TaskSummary";
import TaskDetailsEditable from "./TaskDetailsEditable";

import { Card } from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

export default class TaskCard extends Component {
  public state = {
    isSummaryView: true
  };

  constructor(public props) {
    super(props);

    let isSummaryView = true;

    if (this.props.dialogPresentation) {
      isSummaryView = false;
    }

    if (typeof this.props.isSummaryView !== "undefined") {
      isSummaryView = this.props.isSummaryView;
    }

    this.state.isSummaryView = isSummaryView;
  }

  public changeView = () => {
    this.setState({ isSummaryView: !this.state.isSummaryView })
  }

  public render() {
    return (
      <Card
        className="card no-padding"
        style={{ position: "relative" }}
        onClick={this.state.isSummaryView ? this.changeView : null}
      >
        <div
          className="right-buttons"
          style={{
            position: "absolute",
            right: 0,
            width: "100%",
            height: "40px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "end"
          }}
          onClick={!this.state.isSummaryView ? this.changeView : null}
        >
          {
            this.state.isSummaryView ?
              <ExpandMore style={{ cursor: "pointer", marginTop: "6px" }} onClick={this.changeView} /> :
              <ExpandLess style={{ cursor: "pointer", marginTop: "6px" }} onClick={this.changeView} />
          }
        </div>

        <div className="main-inner-wrapper" style={{ padding: "10px 40px 10px 10px", marginBottom: "10px" }}>
          {
            this.state.isSummaryView && <TaskSummary {...this.props} />
          }

          {
            !this.state.isSummaryView && <TaskDetailsEditable {...this.props} />
          }
        </div>
        <div style={{ height: "1px" }}></div>
      </Card>
    );
  }
}
